import { action, computed, makeObservable, observable } from 'mobx'

import {
  DAY_COLUMN_WIDTH,
  FIRST_COLUMN_WIDTH,
  TAPECHART_ROW_BASE_HEIGHT,
} from '@new/domains/fastBookingsTapeChart/config/contants'

const LOCAL_STORAGE_MAXIMISED_KEY = 'tapechartMaximised'

class TapechartGridSizingStore {
  isMobile = false

  private _isFirstColumnCollapsed = false

  constructor() {
    makeObservable<TapechartGridSizingStore, '_isFirstColumnCollapsed' | '_isGridMaximised'>(this, {
      isMobile: observable,
      _isFirstColumnCollapsed: observable,
      stickyButtons: computed,
      _isGridMaximised: observable,
      isFirstColumnCollapsed: computed,
      isGridMaximised: computed,
      firstColumnWidth: computed,
      dayColumnWidth: computed,
      propertyRowHeight: computed,
      prevButtonLeft: computed,
      nextButtonRight: computed,
      toggleFirstColumn: action.bound,
      setGridSizing: action.bound,
    })
  }

  get stickyButtons() {
    return !this.isMobile
  }

  private _isGridMaximised = Boolean(localStorage.getItem(LOCAL_STORAGE_MAXIMISED_KEY))

  get isFirstColumnCollapsed() {
    return this._isFirstColumnCollapsed
  }

  get isGridMaximised() {
    return this._isGridMaximised
  }

  get firstColumnWidth() {
    if (!this.isMobile) {
      return FIRST_COLUMN_WIDTH.DESKTOP
    }
    if (this._isFirstColumnCollapsed) {
      return FIRST_COLUMN_WIDTH.MOBILE_COLLAPSED
    }
    return FIRST_COLUMN_WIDTH.MOBILE
  }

  get dayColumnWidth() {
    if (this.isMobile) {
      return DAY_COLUMN_WIDTH.MOBILE
    }
    if (this.isGridMaximised) {
      return DAY_COLUMN_WIDTH.DESKTOP_MAXIMISED
    }
    return DAY_COLUMN_WIDTH.DESKTOP
  }

  get propertyRowHeight() {
    if (this.isMobile) {
      return TAPECHART_ROW_BASE_HEIGHT.MOBILE
    }
    if (this.isGridMaximised) {
      return TAPECHART_ROW_BASE_HEIGHT.DESKTOP_MAXIMISED
    }
    return TAPECHART_ROW_BASE_HEIGHT.DESKTOP
  }

  get prevButtonLeft() {
    return this.firstColumnWidth
  }

  get nextButtonRight() {
    return 0
  }

  toggleFirstColumn() {
    this._isFirstColumnCollapsed = !this._isFirstColumnCollapsed
  }

  setGridSizing(maximised: boolean) {
    this._isGridMaximised = maximised
    if (maximised) {
      localStorage.setItem(LOCAL_STORAGE_MAXIMISED_KEY, 'true')
    } else {
      localStorage.removeItem(LOCAL_STORAGE_MAXIMISED_KEY)
    }
  }
}

export const tapechartGridSizingStore = new TapechartGridSizingStore()
